export default __webpack_public_path__ + "static/media/WhiteLogo.16980684.png";